import style from './style.css';

const limitCheckInfo = {
  501: { text: 'MYHDFC', number: 5676712, smsPrefillTxt: 'MYHDFC' },
  701: { text: 'CARDLESS', number: 5676766, smsPrefillTxt: 'CARDLESS' },
  401: {
    text: (
      <div className={`text-center bold-text font20`}>
        DCEMI<span className={style.innerText}>{'<space><'}</span>
        {'Last 4 digits of Kotak Debit Card Number'}
        <span className={style.innerText}>{'>'}</span>
      </div>
    ),
    number: 5676788,
    smsPrefillTxt: 'DCEMI <Last 4 digits of Kotak Debit Card Number>',
  },
  901: {
    text: (
      <div className={`text-center bold-text font20`}>
        PAPL<span className={style.innerText}>{'<space><'}</span>
        {'Last 4 digits of Debit Card Number'}
        <span className={style.innerText}>{'>'}</span>
      </div>
    ),
    number: 8422009988,
    smsPrefillTxt: 'PAPL <Last 4 digits of Debit Card Number>',
  },
  102: { text: 'DC EMI', number: 5686762, smsPrefillTxt: 'DC EMI' },
  201: {
    text: (
      <div className={`text-center bold-text font20`}>
        EASYBUY<span className={style.innerText}>{'<space><'}</span>
        {'Last 4 digits of IDFC FIRST Bank card number'}
        <span className={style.innerText}>{'>'}</span>
      </div>
    ),
    number: 5676732,
    smsPrefillTxt: 'EASYBUY <Last 4 digits of IDFC FIRST Bank card number>',
  },
};

export default limitCheckInfo;



// WEBPACK FOOTER //
// ./components/partial/layers/modals/onLimitCheckModal/limitCheckInfo.js